var $export = require('./$.export');

$export($export.S + $export.F, 'Object', {classof: require('./$.classof')});


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/core.object.classof.js
// module id = 1146
// module chunks = 0